/**
 * generateCorrelationId returns a 32 character "probably UUID" value
 * using pretty dumb math.
 *
 * Using a purely native solution removes bloat from the final bundle size, and correlation
 * ids have an implicit time bound (i.e., the window of time when the request occurred).
 *
 * This code works as follows:
 * 1) Create an empty array with a length of 4
 * 2) Fill that array with 0s so we can map over it
 * 3) Refill the array with a random number between 0 and 4294967295.
 *    A value larger will result in a string larger than 8 characters
 *    and ultimately 32 characters when joined at the end.
 * 4) Convert that to hexadecimal (radix of 16), resulting in values
 *    between 0 and FFFFFFFF.
 * 5) Join the hex fragments
 * 6) Pad the remainder with 0s.
 */
const generateCorrelationId = () =>
  Array(4)
    .fill(0)
    .map(() => Math.floor(Math.random() * 4294967295).toString(16))
    .join('')
    .padEnd(32, '0');

export { generateCorrelationId };
